<h2 mat-dialog-title>
  Change Parameters
  <button mat-icon-button class="close-icon" (click)="closeIconClick()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div *ngFor="let group of groups" class="factor-group">
    <div class="group-header">
      <span>{{ group.name }}</span>
      <mat-slide-toggle [(ngModel)]="group.enabled" (change)="toggleGroup(group)" [disabled]="group.toggle === false">
      </mat-slide-toggle>
    </div>

    <div class="factor-item" *ngFor="let factor of group.factors">
      <span>{{ factor.name }}</span>
      <mat-slide-toggle
        [(ngModel)]="factor.enabled"
        (change)="updateGroupState(group)">
      </mat-slide-toggle>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="reset" style="margin-right: 2px;" (click)="reset()">Reset</button>
  <button class="btn" (click)="save()">Save</button>
</mat-dialog-actions>
